module.exports = __webpack_public_path__ + "static/p04_burroCabeza-04f52ed183018881c3864c13fc78076e.png";